import { useBillingSummaryQuery } from '../queries/useBillingSummaryQuery'

export const useBillingSummary = () => {
  const { billingSummaryQuery } = useBillingSummaryQuery()

  return {
    accountBalance: {
      value: billingSummaryQuery.data?.profit.value,
    },
  }
}
